// extracted by mini-css-extract-plugin
module.exports = {"image":"_5b10bb2305--image--_Qs1b"};